import { render, staticRenderFns } from "./newborn.vue?vue&type=template&id=ff98888c&scoped=true&"
import script from "./newborn.vue?vue&type=script&lang=js&"
export * from "./newborn.vue?vue&type=script&lang=js&"
import style0 from "./newborn.vue?vue&type=style&index=0&lang=css&"
import style1 from "./newborn.vue?vue&type=style&index=1&id=ff98888c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff98888c",
  null
  
)

export default component.exports